import { ProgressBar } from "primereact/progressbar";
import { useEffect } from "react";
import UpdateCustomerComponent from "../../../components/Customer/UpdateCustomer";
import { APP_URLS } from "../../../constants/urlConstants";
import { connect } from "react-redux";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import {
  editCustomer,
  fetchCustomerById,
  fetchCustomerCountriesProviderDD,
  fetchCustomerCurrenciesProviderDD,
  fetchTypeDropdown,
} from "../../../Redux/Actions/customer";
import { setIsformDirty } from "../../../Redux/Actions/common/form";

const UpdateCustomerScreen = (props) => {
  const {
    history,
    match,
    fetchCustomerById,
    editCustomer,
    formFieldValueMap,
    isLoading,
    isCustomerDetailSuccess,
    isCustomerDetailError,
    isEditCustomerSuccess,
    isUpdateCustomerError,
    shouldBlockNavigation,
    fetchCustomerCurrenciesProviderDD,
    fetchCustomerCountriesProviderDD,
    customerCurrenciesProviderDD,
    customerCountriesProviderDD,
    taxTypeDD,
    revenueTypeDD,
    fetchTypeDropdown
  } = props;

  const { id } = props.match.params;

  useEffect(() => {
    if (id) {
      fetchCustomerById(id);
      fetchCustomerCurrenciesProviderDD();
      fetchCustomerCountriesProviderDD();
      fetchTypeDropdown("TAX_TYPE");
      fetchTypeDropdown("REVENUE_TYPE");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (isEditCustomerSuccess) {
      navigateToCustomerSummaryScreen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditCustomerSuccess]);

  const navigateToCustomerSummaryScreen = () => {
    history.push(APP_URLS.CUSTOMER.HOME);
  };

  const updateCustomerProps = {
    editCustomer,
    formFieldValueMap,
    isEditCustomerSuccess,
    isCustomerDetailSuccess,
    isUpdateCustomerError,
    isLoading,
    navigateToCustomerSummaryScreen,
    shouldBlockNavigation,
    isEdit: true,
    customerCurrenciesProviderDD,
    customerCountriesProviderDD,
    taxTypeDD,
    revenueTypeDD,
  };

  const getToastProps = () => {
    if (isEditCustomerSuccess) {
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle: "Customer Updated Successfully",
        shouldShowToast: true,
      };
    }

    if (isCustomerDetailError || isUpdateCustomerError) {
      let toastTitle = "Error while Updating Customer";
      if (isCustomerDetailError) {
        toastTitle =
          "Error fetching customer data. Please refresh your browser.";
      }
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <UpdateCustomerComponent {...updateCustomerProps} />
    </>
  );
};

// SELECTOR HELPERS
const selectFromCustomerReducer = ({ customerReducer }) => customerReducer;

const selectCustomerReducerPath = (state, path) =>
  selectFromCustomerReducer(state)[path];

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectCustomerReducerPath(state, "isLoading"),
    isCustomerDetailSuccess: selectCustomerReducerPath(
      state,
      "isCustomerDetailSuccess"
    ),
    isCustomerDetailError: selectCustomerReducerPath(
      state,
      "isCustomerDetailError"
    ),
    isEditCustomerSuccess: selectCustomerReducerPath(
      state,
      "isEditCustomerSuccess"
    ),
    isUpdateCustomerError: selectCustomerReducerPath(
      state,
      "isUpdateCustomerError"
    ),
    customerCurrenciesProviderDD: selectCustomerReducerPath(
      state,
      "customerCurrenciesProviderDD"
    ),
    customerCountriesProviderDD: selectCustomerReducerPath(
      state,
      "customerCountriesProviderDD"
    ),
    formFieldValueMap: selectCustomerReducerPath(state, "formFieldValueMap"),
    taxTypeDD: selectCustomerReducerPath(state, "taxTypeDD"),
    revenueTypeDD: selectCustomerReducerPath(state, "revenueTypeDD"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCustomerById: (id) => dispatch(fetchCustomerById(id)),
  editCustomer: (payload) => dispatch(editCustomer(payload)),
  shouldBlockNavigation: (isFormDirty) => dispatch(setIsformDirty(isFormDirty)),
  fetchCustomerCurrenciesProviderDD: () =>
    dispatch(fetchCustomerCurrenciesProviderDD()),
  fetchCustomerCountriesProviderDD: () =>
    dispatch(fetchCustomerCountriesProviderDD()),
  fetchTypeDropdown: (type) => dispatch(fetchTypeDropdown(type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateCustomerScreen);
